import { render, staticRenderFns } from "./FormularioDCB.vue?vue&type=template&id=281ada0c&scoped=true"
import script from "./FormularioDCB.vue?vue&type=script&lang=js"
export * from "./FormularioDCB.vue?vue&type=script&lang=js"
import style0 from "./FormularioDCB.vue?vue&type=style&index=0&id=281ada0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ada0c",
  null
  
)

export default component.exports